/**
 * Suppress iOS/background media errors (ERR1608) so they don't show the runtime error overlay.
 * Import this first in index.tsx so listeners are registered before React's error overlay.
 */
const isKnownMediaError = (msg: string) =>
  msg.includes('No audio output devices') ||
  msg.includes('ERR1608') ||
  msg.includes('ERR1100') ||
  msg.includes('Unsupported concurrent calls') ||
  msg.includes('No speaker found') ||
  msg.includes('LocalMediaHandler') ||
  msg.includes('AwaitQueue stopped') ||
  msg.includes('Socket is not connected');

window.addEventListener(
  'error',
  (event) => {
    const msg = typeof event.message === 'string' ? event.message : '';
    if (isKnownMediaError(msg)) {
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation?.();
      console.warn('Media error suppressed (e.g. after background):', msg);
      return true;
    }
  },
  true
);

function getRejectionMessage(reason: unknown): string {
  if (typeof reason === 'string') return reason;
  if (reason instanceof Error) return reason.message;
  if (reason && typeof reason === 'object') {
    const o = reason as Record<string, unknown>;
    if (typeof o.message === 'string') return o.message;
    if (typeof o.error === 'string') return o.error;
    if (o.error && typeof (o.error as Error).message === 'string')
      return (o.error as Error).message;
    try {
      return JSON.stringify(reason);
    } catch {
      // ignore
    }
  }
  return String(reason ?? '');
}

window.addEventListener(
  'unhandledrejection',
  (event) => {
    const msg = getRejectionMessage(event.reason);
    if (isKnownMediaError(msg)) {
      event.preventDefault();
      event.stopImmediatePropagation?.();
      console.warn('Media promise rejection suppressed:', msg);
    }
  },
  true
);

export {};
